export default {
  'dbi_label_trend%': 'Trend(%)',
  dbi_top_recent: 'Recent',
  dbi_top_gametitle: 'Game',
  dbi_top_gametitle_b: 'Game B',
  dbi_top_plan: 'Plan',
  dbi_top_dataai_genre: 'data.ai Genre',
  dbi_top_sensortower_genre: 'Sensor Tower Genre',
  dbi_top_iegg_genre: 'IEGG Genre',
  dbi_top_genre: 'Genre',
  dbi_top_revenue_per_download: 'Revenue Per Download',
  dbi_top_editions: 'Editions',
  dbi_top_charts: 'Top Charts',

  dbi_unified_game_details: 'Unified Game Details',
  dbi_pc_console_content: 'For more game metrics, please refer to PC & Console Games.',
  dbi_pc_console_metrics_table_intro: "The system applies differentiated configurations based on each game's data availability across third-party sources such as MScience, Gamalytic, and VGInsight, and preprocesses the raw data through cross-source fusion, missing value imputation, and time-granularity alignment. On this basis, key milestone data points collected from public channels — including media reports, social platforms, and corporate financial disclosures — are introduced as authentic reference points to perform segmented calibration on the cumulative trend curve, which is then decomposed back into daily, weekly, and monthly sales increments. Finally, by incorporating historical price trends and regional price ratios, the system derives the corresponding revenue figures at each time granularity.",
  dbi_settings_saved: 'Cancel',
  dbi_confirm_note: 'Note',
  dbi_go_pc_console: 'Go To',
  dbi_not_again: "Don't ask again",
  dbi_edition_game_details: 'Edition Game Details',
  dbi_leave_your_feedback: 'Share True Data',
  dbi_performance_summary: 'Performance Summary',
  dbi_combine_engagement: 'Engagement',
  dbi_combine_engagement_tips: 'The total value of engagement related KPIs in the current game',
  dbi_combine_engagement_tips1: 'The data is based on public user profiles collected from game platforms.',
  dbi_combine_engagement_tips2:
    'It provides engagement data for PC/console games, covering 48 countries globally, with daily/monthly granularity.',
  dbi_combine_engagement_tips3: 'Daily data has a 1-week delay, while monthly data has a 1-month delay.',
  dbi_combine_usrevenue_units: 'US Revenue & Units',
  dbi_combine_us_mscience_zero_tip: `Data comes from 'icon' MScience.`,
  dbi_combine_us_mscience_one_tip: 'MScience mainly collects data through e-receipts from data vendor.',
  dbi_combine_us_mscience_two_tip:
    'It provides digital revenue for PC/Console games, US, UK, France, Germany, and Spain data only, with daily/monthly granularity.',
  dbi_combine_us_mscience_three_tip: 'The U.S. data has a ​6-day delay, while European data is delayed by ​7–14 days.',
  dbi_combine_us_revenue_units_tip:
    'As the sampling data for the U.S. market is more extensive, it provides more accurate and reliable insights. Therefore, we default to displaying only U.S. data.',
  dbi_combine_usrevenue_lifetime: 'Lifetime',
  dbi_combine_usrevenue_d1after_release: 'Day 1 after Release',
  dbi_combine_usrevenue_w1after_release: 'Week 1 after Release',
  dbi_combine_usrevenue_m1after_release: 'Month 1 after Release',
  dbi_combine_usrevenue_y1after_release: 'Y1 after release',
  dbi_combine_usrevenue_y1after_ea: 'Y1 after EA',
  dbi_combine_usrevenue_last_month: 'Last month',
  dbi_combine_steam_Data: 'Steam Data',
  dbi_combine_steam_Data_tips: 'The total KPI data value of the current game from the Steam platform',
  dbi_combine_steam_Data_tips1:
    'VG Insights integrates data from the Steam API, IGDB API, and partially from SteamSpy.',
  dbi_combine_steam_Data_tips2:
    'VG Insights provides data for PC steam games. It only has global aggregated data, no country breakdown, with daily/weekly/monthly granularity.',
  dbi_combine_steam_Data_tips3: 'The Steam platform data is sourced from the official Steam website.',
  dbi_combine_steam_Data_tips4: 'VG Insights data and scraped Steam platform data have a 0–2 day delay.',
  dbi_combine_steam_Data_tips_and: '{vginsights} and crawled from the {steam} platform.',
  dbi_combine_steam_Data_gamalytic_tips1:
    'Gamalytic integrates data from the Steam API, IGDB API, and partially from SteamSpy.',
  dbi_combine_steam_Data_gamalytic_tips2:
    'Gamalytic provides data for PC steam games. It only has global aggregated data, no country breakdown, with daily/weekly/monthly granularity.',
  dbi_combine_steam_Data_gamalytic_tips4: 'Gamalytic data and scraped Steam platform data have a 0–2 day delay.',
  dbi_combine_databrain_data_tips_title: 'DataBrain Calibration Data',
  dbi_combine_databrain_data_tips_desc:
    'It provides total revenue and base game sales units, global only, PC&Console combined data only.',
  dbi_combine_databrain_data_tips_update: 'Data Update: 7-day delay.',
  dbi_combine_streaming: 'Streaming',

  // DataBrain KPI Trends metrics
  dbi_metric_total_revenue: 'Total Revenue($)',
  dbi_metric_lifetime_total_revenue: 'Lifetime Total Revenue($)',
  dbi_metric_base_game_sales_units: 'Base Game Sales Units',
  dbi_metric_lifetime_base_game_sales_units: 'Lifetime Base Game Sales Units',
  dbi_metric_mscience_lifetime_digital_revenue: 'Lifetime Digital Revenue($)',
  dbi_metric_mscience_lifetime_digital_units: 'Lifetime Digital Units',
  dbi_true_data_points: 'True Data Points',
  dbi_alinea_true_data_suffix: 'True data',
  dbi_combine_streaming_tips: `The total KPI value of the current game's streaming is sourced from Stream Hatchet`,
  dbi_combine_stream_tips1:
    'Stream Hatchet has an API partnership with Twitch, while collaboration with other platforms remains undisclosed.',
  dbi_combine_stream_tips2:
    'It provides streaming data (Twitch/YouTube, etc.) for mobile/PC/console games, including esports and streamer metrics.',
  dbi_combine_stream_tips3: 'Daily granularity is available, with a 2-day delay.',
  dbi_editions_list: 'Editions List',
  dbi_about_the_game: 'About The Game',
  dbi_screenshots: 'Screenshots',
  dbi_timeline: 'Timeline',
  dbi_downloadable_content: 'Downloadable Content',
  dbi_similar_games: 'Similar Games',
  dbi_related_content: 'Related Content',
  dbi_competitors: 'Competitors',
  dbi_steam_news_announcements: 'Steam News & Announcements',
  dbi_revenue_dollar: 'Revenue($)',
  dbi_select_any_genre: 'Select any genre',
  dbi_select_any_game: 'Select any game',
  dbi_shortcut: 'Shortcut',
  dbi_genre_and: 'And',
  dbi_genre_or: 'Or',
  dbi_choose_andor_for: 'Choose And/Or for Sub Genre',
  dbi_no_results_found: 'No results found',
  dbi_no_search_results_found: 'No quick match found. Press Enter to search for more games',
  dbi_choose_andor_for_tips: `The maximum genre for a single game consists of one main genre and two sub genre. When choosing 'And', you can select up to two sub genre, and the game genre must simultaneously meet the selected sub genre. When choosing 'Or', the game must meet at least one of the selected genre.`,

  dbi_top_charts_table_selection_limit_title: 'Sorry',
  dbi_top_charts_table_selection_limit_tips: 'Please select {num} items at most for the best visualization experience.',

  dbi_top_pheat_value: `P.Heat Value`,
  dbi_top_pheat_chart: `P.Heat Chart`,
  dbi_top_pheat: `P.Heat`,
  dbi_top_following_group: 'Group',

  dbi_metric_not_suitable:
    'The current metric is not suitable for displaying visualization in line or pie charts, check the data in the table below or jump to the game detail page for more details.',

  dbi_top_sales_platform: 'Sales Platform',
  dbi_top_sales_of_selected_time: 'Sales of selected time',
  dbi_top_sales_of_selected_time$: 'Sales of selected time($)',
  dbi_top_price: 'Price',
  dbi_top_price$: 'Price($)',
  dbi_top_revenue_of_selected_time: 'Revenue of selected time',
  dbi_top_revenue_of_selected_time$: 'Revenue of selected time($)',
  dbi_top_cumulative_sales: 'Cumulative Sales',
  dbi_top_cumulative_sales_of_the_latest_week: 'Cumulative Sales of the latest week',
  dbi_top_cumulative_revenue: 'Cumulative Revenue',
  dbi_top_cumulative_revenue_of_the_latest_week: 'Cumulative Revenue of the latest week',
  dbi_top_cumulative_revenue_of_the_latest_week$: 'Cumulative Revenue of the latest week($)',
  dbi_top_console_japan_sales_price_columns_tips:
    'DataBrain converts the yen on the Famitsu ranking list into US dollars using a fixed exchange rate conversion.',
  dbi_top_demographics_breakdown: 'Demographics Breakdown',
  dbi_top_gender_breakdown: 'Gender Breakdown',
  dbi_top_age_breakdown: 'Age Breakdown',
  dbi_top_gender: 'Gender',
  dbi_top_male: 'Male',
  dbi_top_female: 'Female',
  dbi_top_country: 'Country',
  dbi_top_asof: 'As of',

  dbi_detail_data_error: 'Data Related Error',
  dbi_detail_feedback_record: 'Feedback Record',
  dbi_detail_feedback_record_small: 'Feedback Record',
  dbi_detail_feedback_anonymous: 'Anonymous',
  dbi_feedback_please_select_metric: 'Please Select Metric',
  dbi_feedback_please_input_the_metric: 'Please input the metric',
  dbi_feedback_delete_failed: 'Failed Delete',
  dbi_feedback_customize: 'Customize',
  dbi_feedback_e_g_3m: `Example: "300,000 copies" or "4.3 million USD."`,
  dbi_feedback_upload_image: 'Upload Image',
  dbi_feedback_link: 'Link',
  dbi_feedback_link_placeholder: 'https://',
  dbi_EK_Tip: 'Anonymous Release',
  dbi_EK_user: 'Anonymous User',
  dbi_feedback_link_placeholder_EK: 'Specific sources, such as internal employees at miHoYo',
  dbi_feedback_source: 'Data source',
  dbi_true_data_game_name: 'Game Name',
  dbi_feedback_contributor: 'Countributor',
  dbi_feedback_contributor_time: 'Contributed Time',
  dbi_feedback_edit_public_true_data: 'Edit Public True Data',
  dbi_feedback_add_public_true_data: 'Add Public True Data',
  dbi_feedback_public_data: 'Public Data',
  dbi_feedback_expert_knowledge: 'Expert Knowledge',
  dbi_feedback_financial_reports: 'Financial Reports',
  dbi_feedback_public_others: 'Others',
  dbi_top_public_true_data_collection: 'Public True Data Collection',
  dbi_true_data_source_tips:
    'Two verified metric types:\nDatasource True Data: Public true data points manually collected and verified by the Data Science team.\nAlinea Analytics True Data: Public true data points gathered directly from public sources, such as official gaming platforms and social posts from publishers, which are collected by the data vendor itself.',
  dbi_true_data_load_failed: 'Failed to load True Data. Please try again.',
  dbi_true_data_download: 'Download',
  dbi_feedback_you_sure_delete_true_data: 'Are you sure to delete your piece of true data?',
  dbi_feedback_note: 'Note',
  dbi_action: 'Actions',
  dbi_feedback_note_plc: 'Please input the note',
  dbi_feedback_enter_correct_web_site: 'Please enter the correct web site',
  dbi_feedback_data_must_be_in: 'Data must be filled in.',
  dbi_feedback_Metric_must_be_in: 'Metric must be filled in.',
  dbi_feedback_date_must_be_in: 'Date must be filled in.',
  dbi_feedback_game_must_be_in: 'Game must be filled in.',
  dbi_game_placeholder: 'Please select the game',
  dbi_identification_auto: 'Recognize',
  dbi_identification_label: 'Recognize',
  dbi_identification_placeholder: `Example: "In March 2024, Baldur's Gate 3 sold over 15 million units"`,
  dbi_feedback_source_must_be_in: 'Source must be filled in.',
  dbi_feedback_time: 'Time',
  dbi_feedback_once: 'Vague Time',
  dbi_plc_once: 'Please enter the approximate time.',
  dbi_detail_post_anonymously: 'Post it Anonymously',
  dbi_detail_no_feedback_the_moment: 'No feedback at the moment.',
  // dbi_detail_post_anonymously_on_the_switch: 'You can post under your real name or anonymously by turning on the switch.',
  dbi_detail_basic_information_error: 'Basic Information Error',
  dbi_detail_true_data: 'True Data',
  dbi_detail_missing_data: 'Missing Data',
  dbi_detail_feature_suggestion: 'Feature Suggestion',
  dbi_top_free: 'Free',
  dbi_top_new_free: 'New Free',
  dbi_top_paid: 'Paid',
  dbi_top_new_paid: 'New Paid',
  dbi_top_grossing: 'Grossing',
  dbi_top_ratings: 'Ratings',
  dbi_top_xbox_upcoming: 'Xbox Upcoming',
  dbi_top_xbox_most_played: 'Xbox Most Played',

  dbi_detail_jump_to_options: 'Jump to Opinions',
  dbi_detail_feeds: 'Feeds',
  dbi_detail_strengths_weakness: 'Strengths & Weakness',
  dbi_detail_mentions_sentiment: 'Mentions & Sentiment',
  dbi_detail_mentions: 'Mentions',
  dbi_detail_sentiment: 'Sentiment',
  dbi_detail_no_data_under: 'No data under current filter selections.',
  dbi_mobile_stats_active_users_table_nodata:
    "Active data isn't available yet. Sensor Tower provides active data only after a game has been live for at least one week and reached 500,000 global lifetime downloads.",
  dbi_detail_translate: 'Translate',
  dbi_detail_volume_of_mentions: 'Volume of Mentions',
  dbi_detail_games_store: 'Games store',
  dbi_detail_news_media: 'News Media',

  dbi_create_new_group: 'Create a New Group',
  dbi_delete_group: 'Delete Group',
  dbi_duplicate: 'Duplicate',
  dbi_no_following_games_yet: 'No following games yet,',
  dbi_top_please: 'please',
  dbi_follow_new_games: 'Follow new games',
  dbi_follow_new_companies: 'Follow new companies',
  dbi_there_no_game_group: 'There is no game in the current group.',
  dbi_there_no_companies_group: 'There is no companies in the current group.',
  dbi_add_to_group: 'Add to a group',
  dbi_rename_group: 'Rename Group',
  dbi_group_name: 'Group name',
  dbi_new_group: 'New Group',
  dbi_not_include_these_characters: `Please enter a name that doesn't include any of these characters:`,
  dbi_group_name_exists: 'This group name already exists.',
  dbi_group_created_success: 'Group created successfully!',
  dbi_group_created_failed_again: 'Group creation failed, please try again.',
  dbi_rename_failed_again: 'Rename failed, please try again.',
  dbi_maximum_characters: 'Maximum 30 Characters',
  dbi_name_the_group: 'Please name the Group',
  dbi_success_delete: 'Success Delete',
  dbi_success_opt: 'Successfully Operated',
  dbi_group_delete_failed_again: 'Failed Delete, please try again.',
  dbi_want_delete_this_group: 'Do you want delete this group?',
  dbi_games_group_will_move_to: 'Games in this group will move to',
  dbi_followed_successfully: 'Followed successfully',
  dbi_followed_failed_again: 'Followed failed, please try again.',
  dbi_added_failed_again: 'Added failed, please try again.',
  dbi_successfully_added: 'Successfully added!',
  dbi_add_to: 'Add to',
  dbi_move_to: 'Move to',
  dbi_subscription_date: 'Subscription Date',
  dbi_top_metric: 'Metric',
  dbi_top_search_zone_here_and: 'Search genre here.',

  dbi_segment_full_game_key: `Base Game`,
  dbi_segment_MTX_key: `MTX`,
  dbi_segment_DLC_all_other_key: `DLC: All Other`,
  dbi_segment_DLC_expansion_key: `DLC: Expansion`,
  dbi_segment_DLC_content_pre_purchase_pass_key: `DLC: Season Pass`,
  dbi_segment_DLC_unlockable_content_pass_key: `DLC: Battle Pass`,
  dbi_segment_subscription_key: `Subscription`,
  dbi_segment_in_game_currency_key: 'In-Game Currency',

  dbi_segment_all: 'All',
  dbi_segment_full_game: `A purchase that allows you to play the game. Includes editions with bonus content and standalone expansions.`,
  dbi_segment_MTX: `A repeatable purchase that requires a base game. Typically, in-game currency, card packs, loot boxes, etc.`,
  dbi_segment_DLC_all_other: `Content purchased once per account that has not been broken out into the above buckets (e.g. a skin pack purchased with cash). For smaller games, "DLC: Unlockable Content Pass", "DLC: Content Pre-Purchase Pass", or "DLC: Expansion" may not be broken out yet, so all DLC content would be categorized under "DLC: All Other". If there is a game you would like to prioritize, please reach out to our team and we will be happy to assist.`,
  dbi_segment_DLC_expansion: `Content that a user purchases once per account that provides access to expansion content (e.g. content that expands the gameplay through new areas, story, and features)`,
  dbi_segment_DLC_content_pre_purchase_pass: `These are transactions that pre-purchase unreleased DLC content for the account that made the purchase.`,
  dbi_segment_DLC_unlockable_content_pass: `These are transactions that provide progression-based unlockable content for the account that made the purchase.`,
  dbi_segment_subscription: `An auto-recurring purchase. Only broken out for some games.`,

  dbi_delivery_time_dau: `The delivery time for DAU and WAU data of data.ai is the Saturday of next week.`,
  dbi_delivery_time_revenue: 'The delivery time of Revenue and Downloads data of data.ai is the day after tomorrow.',
  dbi_delivery_time_common:
    'The delivery time for DAU and WAU data of data.ai is the Saturday of next week, and that of Revenue and Downloads data of data.ai is the day after tomorrow.',

  dbi_genrefeedback_title: 'Genre Feedback',
  dbi_genrefeedback_desc:
    'You can edit to adjust the genre. When we receive feedback, we will conduct an internal review and then make adjustments.',
  dbi_genrefeedback_main_genre_search_placeholder: 'Search any main genre',
  dbi_genrefeedback_sub_genre_search_placeholder: 'Search any sub genre',
  dbi_genrefeedback_disabled_confirm_tips: 'Please select one main genre and two sub genres.',

  dbi_top_metrictype: 'Metric Type',
  dbi_top_sources: 'Sources',
  dbi_top_granularity: 'Granularity',
  dbi_top_granularity_tips: 'Day/Week/Month granularity correspond to different metrics',
  dbi_top_metric_intotal: 'Metrics ({number})',
  dbi_commpare_metric_metrics_set: 'Metrics Set',
  dbi_detail_game_not_launch_tips: 'The Game is yet to launch.',
  dbi_detail_common_nodata_tips: 'Sorry, no data from all sources.',
  dbi_detail_downloadable_content_nodata_tips: "There's no DLC information in the database.",
  dbi_detail_release_date_by_platform_nodata_tips: 'The release date is not confirmed.',
  dbi_detail_description_nodata_tips: "There's no description of the game in the database.",
  dbi_detail_similar_games_nodata_tips: "We're working out on the similar games.",
  dbi_detail_sensor_tower_tag: 'Sensor Tower Tag',
  dbi_detail_appmagic_tag: 'App Magic Tag',
  dbi_detail_art_style: 'Art Style',
  dbi_detail_camera_pov: 'Camera Pov',
  dbi_detail_product_model: 'Product Model',
  dbi_detail_setting: 'Setting',
  dbi_detail_tags: 'Tags',
  dbi_detail_theme: 'Theme',
  dbi_detail_monetization: 'Monetization',
  dbi_pcdevice_icon_tooltips: 'Other PC devices except Steam and Epic Games',
  dbi_detail_table_allcountries: 'All Countries',
  dbi_detail_table_allgames: 'All Games',
  dbi_detail_table_total: 'Total',
  dbi_detail_revenue_allcountries_tip:
    'Revenue of all countries may be a little smaller because we collect data of 48 core countries.',
  dbi_detail_download_allcountries_tip:
    'Downloads of all countries may be a little smaller because we collect data of 48 core countries.',
  dbi_top_kpiOverview_timeSpentPlaying: 'Time Spent Playing',
  dbi_top_kpiOverview_timeSpentPlaying_info:
    'Average hours played per month for active players.User engagement metrics are currently updated month by month.',
  dbi_top_kpiOverview_timeSpentPlaying_info_come:
    'Data of Avg Monthly Playtime (hours) generated internally by DataBrain',
  dbi_top_kpiOverview_steamGamesOwned: 'Steam Games Owned',
  dbi_top_kpiOverview_steamGamesOwned_info: 'Country distribution of players, based on review languages.',
  dbi_top_kpiOverview_steamGamesOwned_info_come: 'Data of Players by country comes from VG insights',
  dbi_top_learn_more: 'Learn More',
  dbi_top_single_metric: 'Metric',
  dbi_top_comment: 'Comment',
  dbi_top_public_data: 'Public Data Collection',
  dbi_top_public_data_desc: 'The module game data comes from external public information.',
  dbi_top_go_to_original_url: 'Go to original URL',
  dbi_top_very_positive: 'Very Positive',
  dbi_top_positive: 'Positive',
  dbi_top_negative: 'Negative',
  dbi_top_show_more: ' Show other no-update metrics',
  dbi_top_hide_more: 'Collapse other no-update metrics',
  dbi_top_placeholder_metrics: 'Please select Metrics',
  dbi_top_kpiOverview_players_by_country: 'Players by Country',
  dbi_top_kpiOverview_avg_play_time: 'Avg Play Time (Hours)',
  dbi_top_kpiOverview_avg_play_time_hrs: 'Avg Play Time(hrs)',
  dbi_top_kpiOverview_median_play_time: 'Median Play Time (Hours)',

  dbi_top_pc_console_filter_reset: 'Clicking this will clear all custom filters.',
  dbi_top_compare_modal_context: 'Are you sure to delete the game?',
  dbi_operation_successful_tips: 'Operate Successfully!',

  dbi_top_steam_tags: 'Steam Tags',
  dbi_top_steam_tags_tip: 'Steam Tags come from the Steam platform, added by players.',
  dbi_top_steam_tags_placeholder: 'Select any Steam Tags',
  dbi_top_steam_tags_search_placeholder: 'Search any steam tags',
  dbi_steam_tags_logic_label: 'Choose And/Or for Tags',
  dbi_steam_tags_logic_tip: 'When choosing "And", the game must meet all the tags simultaneously; when choosing "Or," the game will be selected as long as it meets any one of the tags.',

  dbi_top_game_mode: 'Game Mode',
  dbi_top_game_mode_tip: 'Tags from the game pages on the Steam platform.',
  dbi_top_game_mode_placeholder: 'Select any game modes',
  dbi_top_game_mode_search_placeholder: 'Search any game mode',
  dbi_top_publisher_class_placeholder: 'Select any publisher classes',
  dbi_top_publisher_class_search_placeholder: 'Search any publisher class',
  dbi_top_publisher_class_tip: 'Classifies publishers by estimated cumulative revenue from {gamalyticDataSourceIcon} Gamalytics, {alineaDataSourceIcon} Alinea, and {mscienceDataSourceIcon} MScience, using the highest available estimate to reduce single-source coverage bias from limited coverage of GaaS revenue. Covers PC market revenue and is updated weekly.',

  dbi_top_game_engine: 'Game Engine',
  dbi_supported_platforms: 'Supported Platforms',
  dbi_top_game_engine_tip: 'The game development framework. Tags come from the IGDB platform.',
  dbi_top_game_engine_placeholder: 'Select any game engines',
  dbi_top_game_engine_search_placeholder: 'Search any game engine',
  dbi_game_engine_logic_label: 'Choose And/Or for Game Engine',
  dbi_game_engine_logic_tip: 'When choosing "And", the game must meet all the tags simultaneously; when choosing "Or," the game will be selected as long as it meets any one of the tags.',

  dbi_top_steam_news_jump_tip: 'Go to original page for more game activities',

  dbi_top_data_issue: 'Data Issue',

  dbi_top_show_all_true_data_text: 'Show All True Data',
  dbi_top_calibration_metrics_switcher_text: 'Switch to Calibration Metrics',
  dbi_top_calibration_metrics_switcher_tips:
    'This game has DataBrain calibration data. Click to switch to calibration metrics.',
  dbi_top_calibration_metrics_switcher_disabled_tips: 'You have been switched to calibration metrics.',
  dbi_sensortower_tags: 'Sensor Tower Tags',

  dbi_top_appmagic_genre: 'App Magic Genre',

  dbi_show_rising_games: 'Show Rising Games',

  // Surge Metric
  dbi_surge_metric_placeholder: 'Surge Metric',
  dbi_surge_metric_dau: 'DAU Surge',
  dbi_surge_metric_wau: 'WAU Surge',
  dbi_surge_metric_mau: 'MAU Surge',
  dbi_surge_metric_revenue: 'Revenue($) Surge',
  dbi_surge_metric_download: 'Download Surge',
  dbi_surge_metric_units: 'Units Surge',
  dbi_surge_metric_pcu: 'PCU Surge',
  dbi_surge_metric_tooltip_mobile:
    'Show the Top 500 games by the selected metric under the current filter condition, sorted in descending order by change rate. After selecting a Surge metric, operations such as resorting the table below will apply only to the current Top 500 games. Uncheck the metrics to restore the default top charts.',
  dbi_surge_metric_tooltip_combine:
    'Show the Top 500 games by the selected metric under the current filter condition, sorted in descending order by change rate. After selecting a Surge metric, operations such as resorting the table below will apply only to the current Top 500 games. Uncheck the metrics to restore the default top charts.\nRevenue is based on the MScience revenue metric, unit sales are based on the MScience units metric, PCU is sourced from official Steam PCU data, and DAU/MAU are based on the Other Vendor DAU/MAU metrics.',

  // Steam Hourly CCU
  dbi_top_kpiOverview_steam_hourly_ccu: 'Steam Hourly CCU',
  dbi_top_kpiOverview_steam_hourly_ccu_info:
    'Steam current concurrent players, collected hourly from official Steam API. The data scraping started in February 2026.',
  dbi_top_kpiOverview_steam_hourly_ccu_today: 'Today',
  dbi_top_kpiOverview_steam_hourly_ccu_yesterday: 'Yesterday',
  dbi_top_kpiOverview_steam_hourly_ccu_same_day_last_week: 'Same Day Last Week',
  dbi_top_kpiOverview_steam_hourly_ccu_contrast_day: 'Contrast Day',
  dbi_top_kpiOverview_steam_hourly_ccu_dod: 'DoD',
  dbi_top_kpiOverview_steam_hourly_ccu_sdlw: 'SDLW',
  // Top Charts / PC & Console Games / Alinea Analytics Calibration
  dbi_alinea_analytics_calibration: 'Alinea Analytics True data',
  // Top Charts / Event Details
  dbi_top_event_start_date: 'Start date',
  dbi_top_event_end_date: 'End date',
};
// 此文档 新增请改dbi_top_为前缀
